<template>
    <div class="user-wrapper">
        <div class="content">
            <mobile-header>
                <i slot="arrowLeft" class="el-icon-arrow-left" @click="$emit('handleInfoShow')"></i>
                <span slot="title" class="text">个人中心</span> 
            </mobile-header>
            <info-card class="info" from="mobile"></info-card>
            <avatar v-show="isShowAvatar" @hideAvatar="hideAvatar"></avatar>
            <grade-panel v-show="isShowGrade" @hideGrade="hideGrade"></grade-panel>
            <name v-show="isShowName" @hideName="hideName"></name>
            
            <!-- 可滚动的设置区域 -->
            <div class="scroll-content">
                <div class="settings">
                    <!-- 新增订单入口 -->
                    <div class="item" @click="toOrderList">
                        <span class="left">📋 我的订单</span>
                        <div class="right">
                            <i class="el-icon-arrow-right"></i>
                        </div>
                    </div>

                    <div class="item" @click="isShowGrade = true">
                        <span class="left">📚 年级信息</span>
                        <div class="right">
                            <span>{{ user.grade }}</span>
                            <i class="el-icon-arrow-right"></i>
                        </div>
                    </div>

                    <div class="item" @click="isShowName=true">
                        <span class="left">👤 昵称修改</span>
                        <div class="right">
                            <span class="text">{{ user.name }}</span>
                            <i class="el-icon-arrow-right"></i>
                        </div>
                    </div>

                    <div class="item" @click="toAccountManagement">
                        <span class="left">📱 账号管理</span>
                        <div class="right">
                            <span class="text">{{ user.phoneNumber }}</span>
                            <i class="el-icon-arrow-right"></i>
                        </div>
                    </div>

                    <div class="item" @click="toAboutUs">
                        <span class="left">ℹ️ 关于我们</span>
                        <div class="right">
                            <i class="el-icon-arrow-right"></i>
                        </div>
                    </div>

                    <div class="item">
                        <span class="left">🌓 主题模式</span>
                        <div class="right">
                            <img v-show="theme === 'light'" @click="switchTheme('dark')" class="icon"
                                :src="getImage('dark.svg')" />
                            <img v-show="theme === 'dark'" @click="switchTheme('light')" class="icon"
                                :src="getImage('light.svg')" />
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- 固定在底部的退出登录按钮 -->
            <div class="logout" @click="logoutDialogVisible = true">
                退出登录
            </div>
        </div>
        
        <el-dialog top="30vh" title="提示" :visible.sync="logoutDialogVisible" class="logoutDialog"  width="80%"
            :append-to-body="true">
            <div class="warn-info">
                <i class="el-icon-warning logout-warning"></i> 确定退出系统吗？
            </div>
            <span slot="footer" class="dialog-footer base-button">
                <button @click="logoutDialogVisible = false">取 消</button>
                <button type="primary" @click="logout">确 定</button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { logout } from "@/api/login"
import InfoCard from "../../components/user/InfoCard.vue";
import MobileHeader from "./MobileHeader.vue";
import GradePanel from "./gradePanel.vue";
import Avatar from "./avatar.vue";
import Name from "./name.vue"
export default {
    name: 'user',
    components: {
        InfoCard,
        MobileHeader,
        Avatar,
        GradePanel,
        Name
    },
    computed: {
        ...mapState(["theme", "user"])
    },
    data() {
        return {
            logoutDialogVisible: false,
            isShowAvatar: false,
            isShowPhone: false,
            isShowName: false,
            isShowGrade: false,
            // data properties
        }
    },
    mounted() {
        // lifecycle hook
    },
    methods: {
        toAccountManagement() {
            this.$router.push('/account-management');
        },
        toAboutUs() {
            this.$router.push('/about-us');
        },
        toOrderList() {
            this.$router.push('/pay/orders');
        },
        hideAvatar() {
            this.isShowAvatar = false;
        },
        hideGrade() {
            this.isShowGrade = false;
        },
        hideName() {
            this.isShowName = false;
        },
        getImage(imgname) {
            return require(`@/assets/image/theme/` +
                this.theme +
                `/${imgname}`);
        },
        switchTheme(theme) {
            if (this.theme === theme) return;
            this.$store.commit("setTheme", theme);
        },
        async logout() {
            this.dialogVisible = false;
            let res = await logout();
            if (!res || res.status !== 200) {
                // this.$message.error("退出失败");
                // return;
            } else {
                // this.$message.success("退出成功");
            }
            this.logoutDialogVisible = false;
            this.$store.commit("removeUser");
            this.$store.commit("removeToken");
            this.$store.commit("CLEAR_MESSAGE");
            this.$router.push('/login')
        },
    }
}
</script>

<style lang="scss" scoped>
.user-wrapper {
    position: fixed;               /* 固定定位铺满全屏 */
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;                /* 兼容性更好，覆盖所有安卓WebView */
    height: -webkit-fill-available;
    height: 100dvh; 
    padding: 0 10px;
    padding-bottom: env(safe-area-inset-bottom); /* 全局安全区备用 */
    background-color: var(--bg-color-3);
    z-index: 100;
    color: var(--txt-default-color);
    overflow: hidden;             /* 防止内容溢出导致滚动 */
    box-sizing: border-box;       /* padding计入宽高，避免撑大 */
    
    .content {
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    /* 可滚动区域 */
    .scroll-content {
        flex: 1 1 auto;
        min-height: 0;
        overflow-y: auto;
        padding: 10px 0 8px;
    }

    .settings {
        margin-top: 0;
        padding: 0 15px 0 15px;
        background-color: var(--leftbox-bg-color);
        border-radius: 12px;
        overflow: hidden;

        .item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 14px 0;
            border-bottom: 1px solid var(--bg-color-3);
            cursor: pointer;
            transition: background-color 0.15s ease;

            &:active {
                background-color: rgba(0, 0, 0, 0.04);
            }

            &:last-of-type {
                border-bottom: none;
            }

            .left {
                font-size: 15px;
                font-weight: 500;
                color: var(--txt-default-color);
            }

            .right {
                display: flex;
                align-items: center;
                gap: 6px;
                color: var(--gray-5);
                font-size: 14px;

                .text {
                    max-width: 140px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }

                .icon {
                    width: 28px;
                    height: 28px;
                    cursor: pointer;
                    transition: transform 0.2s;
                    &:active {
                        transform: scale(0.92);
                    }
                }

                .el-icon-arrow-right {
                    font-size: 14px;
                    color: var(--gray-4);
                }
            }
        }
    }

    /* 底部退出按钮 */
    .logout {
        flex-shrink: 0;
        margin: 8px 0 12px 0;
        padding: 14px 0;
        padding-bottom: calc(14px + env(safe-area-inset-bottom, 0px)); /* 安全区适配 */
        font-size: 16px;
        font-weight: 600;
        text-align: center;
        border-radius: 14px;
        background: linear-gradient(135deg, #f7bd01, #f5a623);
        color: #fff;
        box-shadow: 0 4px 12px rgba(247, 189, 1, 0.35);
        transition: all 0.2s ease;
        cursor: pointer;
        width: 100%;

        &:active {
            transform: scale(0.97);
            box-shadow: 0 2px 6px rgba(247, 189, 1, 0.2);
        }
    }
}

.logoutDialog {
    min-width: 400px !important;
    
    ::v-deep .el-dialog {
        border-radius: 24px;
        overflow: hidden;
    }
    
    ::v-deep .logout-warning {
        color: #e6a23c;
        font-size: 18px;
    }
    
    .dialog-footer {
        button:last-child {
            margin-left: 10px;
        }
    }
}

/* 移除了对 .content 高度的额外覆盖，避免与父级固定冲突 */
@media (max-width: 1023px) {
    ::v-deep .user {
        z-index: 100 !important;
        width: auto;
        .head {
            margin-bottom: 5px;
        }
    }
}

@media (min-width:750px) {
    .content {
        margin: 0 calc((100vw - 750px) / 2);
        ::v-deep .user {
            width: auto;
        }
    }
}
</style>